// @ts-nocheck
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { GetProductCollectionRealTimePriceApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    LoadRealTimePrices as baseLoadRealTimePrices,
    chain,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import { getKitConfigurationOptionIds } from "@store/Framework/Utilities/KitProductInfoUtilities";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const LoadRealTimePrices = createChainHandler("LoadRealTimePrices", chain, async props => {
    const { wishListLines, productInfosByWishListLineId, replacementProductInfosByWishListLineId } = props;
    if (!wishListLines?.length) {
        props.pricingLoaded = true;
        return;
    }

    /* Store Custom Code - Start */
    type PriceParameter = GetProductCollectionRealTimePriceApiV2Parameter["productPriceParameters"][number];

    const products: PriceParameter[] = wishListLines!.map(o => ({
        productId: o.productId,
        unitOfMeasure: o.unitOfMeasure,
        qtyOrdered: o.qtyOrdered,
        configuration: getKitConfigurationOptionIds(o),
    }));

    const replacementProducts: PriceParameter[] = wishListLines!
        .filter(o => o.replacementProduct?.id)
        .map(o => ({
            productId: o.replacementProduct?.id ?? "",
            unitOfMeasure: o.replacementProduct?.unitOfMeasure ?? "",
            qtyOrdered: o.qtyOrdered,
        }));
    /* Store Custom Code - End */

    const productPriceParameters = products.concat(replacementProducts);

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters,
            onComplete: realTimePricingProps => {
                /* Store Custom Code - Start */
                if (realTimePricingProps?.apiResult) {
                    const results = realTimePricingProps.apiResult.realTimePricingResults;
                    // Only trustworthy when every parameter came back; otherwise fall back to the platform's
                    // productId + unitOfMeasure matching below.
                    const matchByIndex = !!results && results.length === productPriceParameters.length;
                    if (matchByIndex) {
                        wishListLines!.forEach((wishListLine, index) => {
                            const productInfo = productInfosByWishListLineId[wishListLine.id];
                            if (productInfo) {
                                productInfo.pricing = results![index];
                            }
                        });
                    }

                    results?.forEach(pricing => {
                        for (const wishListLineId in productInfosByWishListLineId) {
                            const productInfo = productInfosByWishListLineId[wishListLineId]!;
                            if (
                                !matchByIndex /* Store Custom Code */ &&
                                productInfo.productId === pricing.productId &&
                                productInfo.unitOfMeasure === pricing.unitOfMeasure
                            ) {
                                productInfo.pricing = pricing;
                            }

                            const replacementProductInfo = replacementProductInfosByWishListLineId[wishListLineId];
                            if (
                                replacementProductInfo &&
                                replacementProductInfo.productId === pricing.productId &&
                                replacementProductInfo.unitOfMeasure === pricing.unitOfMeasure
                            ) {
                                replacementProductInfo.pricing = pricing;
                            }
                        }
                    });
                } else if (realTimePricingProps.error) {
                    for (const wishListLineId in productInfosByWishListLineId) {
                        productInfosByWishListLineId[wishListLineId]!.failedToLoadPricing = true;
                    }

                    for (const wishListLineId in replacementProductInfosByWishListLineId) {
                        replacementProductInfosByWishListLineId[wishListLineId]!.failedToLoadPricing = true;
                    }
                }
                props.pricingLoaded = true;
                /* Store Custom Code - End */
            },
        }),
    );

    if (getSettingsCollection(props.getState()).productSettings.inventoryIncludedWithPricing) {
        await waitFor(() => !!props.pricingLoaded);
    }
});

replaceInChain(chain, baseLoadRealTimePrices, LoadRealTimePrices);
